import SoilProvider from './soilProvider';

// export const getMaterialPreviewAsync = MaterialProvider.getMaterialPreviewAsync;

export const getSoilByIdAsync = SoilProvider.getSoilByIdAsync;

// export const getMaterialByCategoryAsync = MaterialProvider.getMaterialByCategoryAsync;

// export const updateMaterialAsync = MaterialProvider.updateMaterialAsync;

export const getPaginatedSoilPreviewsAsync = SoilProvider.getPaginatedSoilPreviewsAsync;

export const getAllSoilAsync = SoilProvider.getAllSoilAsync;

export const insertSoilAsync = SoilProvider.insertSoilAsync;

export const updateSoilAsync = SoilProvider.updateSoilAsync;
